//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from '../../api';

export default {

    beforeRouteEnter: (to, from, next) => {
        next((vm) => {
        });
    },
    components: {
    },
    mounted() {
        this.getInfo();
    },
    watch: {
    },
    data() {
        return {
            truckList: [],
            empty: false,
        };
    },
    computed: {
        companyStatus() {
            return this.$store.state.companyStatus;
        },
    },
    methods: {
        getInfo() {
            api.vega.company.listCompanyTrucks({
                pageNo: 1,
                pageSize: 100,
            }).then((res) => {
                const data = res.data.data.result;
                this.truckList = data;
                if (data.length === 0) {
                    this.empty = true;
                } else {
                    this.empty = false;
                }
            });
        },
        gotoEditTruck() {
            if (this.companyStatus !== 0) {
                this.$router.push({
                    name: 'mineAddTruck',
                });
            } else {
                this.$router.push({
                    name: 'authAddTruck',
                });
            }
        },
        deleTruck(id) {
            api.vega.company.deleteCompanyTruck({
                id,
            }).then((res) => {
                const code = res.data;
                if (code.code === 0 && code.sub_code === 0) {
                    this.getInfo();
                    this.$vux.toast.text('删除成功');
                }
            })
        },
    },
};
